var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAssessmentSaveNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9903 3.00769L9.71251 4.29094C10.5689 5.1478 11.0433 6.28741 11.0433 7.49997C11.0433 9.99941 9.01152 12.0312 6.51208 12.0312V11.125L4.69958 12.9375L6.51208 14.75V13.8437C10.0098 13.8437 12.8558 10.9976 12.8558 7.49997C12.8558 5.80257 12.1938 4.20757 10.9903 3.00769Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32458 2.0625L6.51208 0.25V1.15625C3.01441 1.15625 0.168335 4.00233 0.168335 7.5C0.168335 9.19741 0.830351 10.7924 2.03385 11.9923L3.31166 10.709C2.45526 9.85217 1.98083 8.71256 1.98083 7.5C1.98083 5.00056 4.01265 2.96875 6.51208 2.96875V3.875L8.32458 2.0625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssessmentSaveNew);
export default __webpack_public_path__ + "static/media/IconAssessmentSaveNew.3e45a2b446a92da17d6658e6ee3bd81c.svg";
export { ForwardRef as ReactComponent };